import resume from "../assets/pdf/Suman_Saurav_Resume.pdf";

export const headerData = {
  name: "Suman Saurav",
  title: "Full Stack Developer",
  desciption:
    "Full-stack web developer with experience in building web applications and ensuring seamless user experiences using React keeping web optimization. Ready to contribute effectively to dynamic teams and solve unique, large scale, highly complex technical problems. Seeking full-time in software development engineer-front-end/full-stack roles.",
image:
    "https://avatars.githubusercontent.com/u/101393663?v=4",
  resumePdf: resume,
  resumelink:"https://drive.google.com/file/d/1g7N3TqQm99MVEcwkAe5S0M9kqz94vx__/view?usp=sharing"
};
